import api from "../../../utils/api";
import { setAlert } from "../alert";
import { handleError } from "../errors";
import { DELETE_UPLOADED_DATA, DELETE_UPLOADED_DATA_ERROR, GET_IMPORT_DATA_STATUS_LIST, GET_IMPORT_DATA_STATUS_LIST_ERROR, GET_IMPORT_LOG_BY_REFNUM, GET_IMPORT_LOG_BY_REFNUM_ERROR, GET_IMPORT_LOG_STATUS_LIST, GET_IMPORT_LOG_STATUS_LIST_ERROR, GET_IMPORT_LOGS_LIST, GET_IMPORT_LOGS_LIST_ERROR, IMPORT_VALID_RECORDS, IMPORT_VALID_RECORDS_ERROR, RESET_IMPORTLOG_DETAIL } from "../types";

export const get_import_logs_list = (refNum, importType, payscheduleIds, status, startDate, endDate) => async (dispatch) => {
    try {
        const res = await api.get('api/sub-importlog/get-imports-log-list', {
            params: {
                refNum: refNum,
                importType: importType,
                payScheduleId: payscheduleIds,
                status: status,
                fromDate: startDate,
                toDate: endDate,
            }
        });
        dispatch({
            type: GET_IMPORT_LOGS_LIST,
            payload: res.data
        })
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: GET_IMPORT_LOGS_LIST_ERROR });
    }
}

export const get_import_log_status_list = () => async (dispatch) => {
    try {
        const res = await api.get('api/sub-importlog/get-import-log-status-list');
        dispatch({
            type: GET_IMPORT_LOG_STATUS_LIST,
            payload: res.data
        });
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, 'danger'));
        }
        dispatch({ type: GET_IMPORT_LOG_STATUS_LIST_ERROR });
    }
}

export const get_import_log_by_refnum = (refNum, userId, clientName, workerName, status, payPeriodId, payScheduleId, fromDate, toDate) => async (dispatch) => {
    //
    try {
        const res = await api.get('api/sub-importlog/get-imports-log', {
            params: {
                refNum: refNum,
                userId: userId,
                clientName: clientName,
                workerName: workerName,
                status: status,
                payPeriodId: payPeriodId,
                payScheduleId: payScheduleId,
                fromDate: fromDate,
                toDate: toDate,
            }
        });
        dispatch({
            type: GET_IMPORT_LOG_BY_REFNUM,
            payload: res.data
        })
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: GET_IMPORT_LOG_BY_REFNUM_ERROR });
    }
}

export const delete_uploaded_data = (refNum) => async (dispatch) => {
    try {
        const res = await api.get(`/api/sub-importlog/delete-uploaded-data?refNum=${refNum}`);
        dispatch({
            type: DELETE_UPLOADED_DATA,
            payload: res.data,
        });
        return true;
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, "danger"));
            dispatch({
                type: DELETE_UPLOADED_DATA_ERROR
            });
        }
        return false;
    }
};

export const import_valid_records = (refNum) => async (dispatch) => {
    try {
        const res = await api.get(`/api/sub-importlog/import-valid-records?refNum=${refNum}`);
        dispatch({
            type: IMPORT_VALID_RECORDS,
            payload: res.data,
        });
        return true;
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, "danger"));
            dispatch({
                type: IMPORT_VALID_RECORDS_ERROR
            });
        }
        return false;
    }
};

export const reset_importlog_detail = () => async (dispatch) => dispatch({ type: RESET_IMPORTLOG_DETAIL })

export const get_import_data_status_list = () => async (dispatch) => {
    try {
        const res = await api.get('api/sub-importlog/get-import-data-status-list');
        dispatch({
            type: GET_IMPORT_DATA_STATUS_LIST,
            payload: res.data
        });
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, 'danger'));
        }
        dispatch({ type: GET_IMPORT_DATA_STATUS_LIST_ERROR });
    }
}

//